import React from "react";
import { SvgProps } from "./Form";

export const Bold = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_6774_493)">
      <path
        d="M10.977 7.33151C11.3048 6.80193 11.4851 6.19433 11.4991 5.57165C11.5131 4.94897 11.3604 4.33387 11.0568 3.79007C10.7531 3.24627 10.3096 2.79355 9.77213 2.47881C9.23467 2.16407 8.62283 1.99876 8 2.00001H3.5V14H9.5C10.2967 14.0009 11.0698 13.7296 11.6914 13.2312C12.3129 12.7328 12.7457 12.0371 12.918 11.2592C13.0903 10.4814 12.9918 9.668 12.6388 8.95374C12.2858 8.23948 11.6996 7.66716 10.977 7.33151ZM5.5 4.00001H8C8.39782 4.00001 8.77936 4.15804 9.06066 4.43935C9.34196 4.72065 9.5 5.10218 9.5 5.50001C9.5 5.89783 9.34196 6.27936 9.06066 6.56067C8.77936 6.84197 8.39782 7.00001 8 7.00001H5.5V4.00001ZM9.5 12H5.5V9.00001H9.5C9.89782 9.00001 10.2794 9.15804 10.5607 9.43935C10.842 9.72065 11 10.1022 11 10.5C11 10.8978 10.842 11.2794 10.5607 11.5607C10.2794 11.842 9.89782 12 9.5 12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6774_493">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
